import React, {useEffect, useState} from "react";
import Header2 from "../../common/header/Header2";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import PromoBanner from "../promoBanner.js";
import UserAvatar from "../userAvatar.js";

import "../CryptoPage.css";
import Stack from "@mui/material/Stack";

import "./subscription.css";
import data from "./Subscription.json";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import GoogleLoginHandler from "../../common/hooks/GoogleLoginHandler";
import {BottomNavigation, BottomNavigationAction, IconButton, Box, Button, Typography} from "@mui/material";
import {tabLink} from "../../common/constant/tablink";
import {Tabs, Tab} from "@mui/material";
import {Helmet} from "react-helmet";
import BottomTab from "../../common/hooks/BottomTab";
import LoginPopUp from "../../common/alert/login/LoginPopUp";

const MySubscription = () => {
    const navigate = useNavigate();
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 400,
        })
    );
    const [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);
    const location = useLocation();
    const loc = location.pathname;
    const userData = localStorage.getItem("cw_portfolio_user");
    const [selectedTab, setSelectedTab] = useState(mediaQueryVar ? "Invest" : "Portfolios");

    useEffect(() => {
        const userData = localStorage.getItem("cw_portfolio_user");
        const urlParams = new URLSearchParams(window.location.search);
        const payment = urlParams.get("payment");
        console.log("hello pay:", payment);
        const priceId = "price_1QV4J8KAXtGoEI6mJntRzF1L";

        if (userData && payment === "true" && priceId) {
            console.log("hello pay:", payment);
            const emailId = JSON.parse(userData).email_id;
            handleCheckout(priceId, emailId);

            // Clean up URL to avoid re-triggering on refresh
            const newUrl = window.location.pathname;
            window.history.replaceState({}, "", newUrl);
        }
    }, []);

    const handleModalClose = () => {
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };
    const handleCheckout = async (price_id, email) => {
        try {
            const response = await fetch("https://investing.crowdwisdom.live/create-checkout-session", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({price_id, email}),
            });

            const session = await response.json();

            if (session.error) {
                console.error("Server Error: ", session.error);
                alert(`Error: ${session.error}`);
                return;
            }

            if (session.url) {
                window.location.href = session.url;
            }
        } catch (error) {
            console.error("Error during checkout: ", error);
        }
    };

    useEffect(() => {
        const userData = localStorage.getItem("cw_portfolio_user");
        setIsLoggedIn(userData ? true : false);
    }, []);

    const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);
    const drawerWidth = 292;
    const handleLoginClick = () => {
        // Mask the URL by adding /login at the end without navigating
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        // Open the login modal
        setLoginModalOpen(true);
    };

    const [path, setPath] = useState("/");
    const [mobileOpen, setMobileOpen] = React.useState(false);
    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "4px 8px" : "4px 2px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: "600",
            fontSize: "15px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                        fontSize: "14px",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "14px",
                        }}
                    >
                        {[
                            tabLink["my_subscription"],
                            tabLink["influencer_ranking_prediction"],
                            tabLink["screener"],
                        ].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "130px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "4px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {!mediaQueryVar ? tab.mobile_name : tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>
                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["presale"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };

    const bottomNavigationMobile = [
        tabLink["presale"],
        userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
        tabLink["profile"],
    ];
    const topNavigationMobile = [tabLink["my_subscription"], tabLink["influencer_ranking_prediction"]];
    const onSelectAmount = (price_id) => {
        const userData = localStorage.getItem("cw_portfolio_user");
        if (!userData) {
            const originalUrl = "/subscriptions/?payment=true";
            sessionStorage.setItem("originalUrl", originalUrl);
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");

            // Open the login modal
            setLoginModalOpen(true);

            return;
        } else {
            const userData_full = JSON.parse(userData);

            // Access the email_id
            const emailId = userData_full.email_id;

            console.log("USER DATA:", emailId);
            handleCheckout(price_id, emailId); // Call handleCheckout with the selected amount
        }
    };

    return (
        <div className="d-flex row  w-100 m-0">
            <Helmet>
                <title>My Subscriptions</title>
            </Helmet>
            {mediaQueryVar && <Header2 />}
            {mediaQueryVar === false && (
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Header2
                        bottomNavigationMobile={bottomNavigationMobile}
                        topNavigationMobile={topNavigationMobile}
                    />
                </div>
            )}
            {mediaQueryVar && (
                <div className="content">
                    {/* Top Section: Tabs + My Profile Button + Notification */}
                    <Box>
                        {/* Tabs with My Profile as the first Tab */}
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: drawerWidth,
                                width: `calc(100% - ${drawerWidth}px)`,
                                backgroundColor: "#ffffff",
                                zIndex: 1000,
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                height: "100px", // You may need to increase this if banner + nav exceeds 100px
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <PromoBanner />
                            <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                        </div>

                        {data.map((item, index) => {
                            return (
                                <div className="feature" key={index}>
                                    <div className="feature-title">{item.title}</div>
                                    <button
                                        className="feature-button"
                                        onClick={() => {
                                            console.log("item.state", item.state);
                                            return item.state
                                                ? navigate(item.link, {state: item.state})
                                                : navigate(item.link);
                                        }}
                                    >
                                        {item.link_title}
                                    </button>
                                </div>
                            );
                        })}
                    </Box>
                </div>
            )}
            {mediaQueryVar == false && (
                <div className="content" style={{marginTop: "120px"}}>
                    {/* Top Section: Tabs + My Profile Button + Notification */}
                    <Box sx={{marginTop: "2%", marginBottom: "100px"}}>
                        {data.map((item, index) => {
                            return (
                                <div className="feature-mobile" key={index}>
                                    <div className="feature-title">{item.title}</div>
                                    <button
                                        className="feature-button"
                                        onClick={() => {
                                            console.log("item.state", item.state);
                                            return item.state
                                                ? navigate(item.link, {state: item.state})
                                                : navigate(item.link);
                                        }}
                                    >
                                        {item.link_title}
                                    </button>
                                </div>
                            );
                        })}
                        {/* <Box
                            sx={{
                                border: "2px solid #1877F2",
                                borderRadius: "20px",
                                px: mediaQueryVar2 ? 1 : 2,
                                py: 1,
                                ml: 1.5,
                                mr: 1.5,
                                mb: 3.5,
                                height: mediaQueryVar2 ? "165px" : "140px",
                                display: "flex",
                                alignItems: "flex-start",
                                position: "relative",
                                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                            }}
                        >
                            <Box sx={{position: "absolute", top: 10, left: 10}}>
                                <img
                                    src="/images/yellow-coins.svg"
                                    alt="coins"
                                    style={{width: "28px", height: "28px"}}
                                />
                            </Box>
                        </Box> */}

                        {/* <Box textAlign="center" mb={5}>
                            <Button
                                onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                sx={{
                                    background:
                                        "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                    borderRadius: "50px",
                                    padding: "11px 4px 11px 4px",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    color: "#1877F2",
                                    textTransform: "none",
                                    boxShadow:
                                        "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    border: "2px solid #1877F2",
                                    width: "94%",
                                }}
                            >
                                BUY THE PLAN NOW @ $1/MONTH
                            </Button>
                        </Box> */}

                        {/* <Box> */}
                        {/* Header */}
                        {/* <Box
                                sx={{
                                    width: "95%",
                                    ml: 1.2,
                                    border: "1px solid #1877F2",
                                    borderRadius: "50px",
                                    background:
                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.20) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                    padding: "10px 20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: 700,
                                    fontSize: "18px",
                                    color: "#000",
                                    mb: 4.5,
                                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                    position: "relative",
                                }}
                            >
                                <Box sx={{position: "absolute", left: 20}}>
                                    <img
                                        src="/images/green-steps.svg"
                                        alt="target"
                                        style={{width: "30px", height: "30px"}}
                                    />
                                </Box>
                                <Box sx={{width: "100%", textAlign: "center"}}>WHAT DO YOU GET?????</Box>
                            </Box> */}

                        {/* Rows */}
                        {/* {featuresMobile.map((item, index) => (
                                <Box
                                    key={index}
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    mb={index === 0 ? 10 : index === 1 ? 9 : index === 2 ? 8 : 12}
                                    ml={1.5}
                                    mr={1.5}
                                >
                                    {/* Top Title Box */}
                        {/* <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            padding: "12px 20px",
                                            background:
                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.40) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            fontWeight: "700",
                                            color: "#000",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            fontSize: "16px",
                                            width: "100%",
                                            height: "60px",
                                            lineHeight: "1.2",
                                            textAlign: "left",
                                            whiteSpace: "normal",
                                            mb: index === 2 ? 3 : index === 3 ? 7 : 5,
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            const link = getLinkFromTitle(item.title);

                                            if (!link) return;

                                            if (typeof link === "string") {
                                                navigate(link);
                                            } else if (typeof link === "object" && link.path) {
                                                navigate(link.path, {state: link.state});
                                            }
                                        }}
                                    >
                                        <img
                                            src="/images/red-arrow-point.svg"
                                            alt="target"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                marginRight: mediaQueryVar2 && index == 3 ? "10px" : "50px",
                                            }}
                                        />
                                        {item.title}
                                    </Box> */}

                        {/* Bottom Description Box */}
                        {/* <Box
                                        sx={{
                                            border: "2px solid #1877F2",
                                            borderRadius: "20px",
                                            background: "#fff",
                                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                            width: "98%",
                                            height: "273px",
                                            px: 2,
                                            py: 3,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center", // ✅ Center vertically
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        {item.points.map((point, idx) => (
                                            <Box
                                                key={idx}
                                                display="flex"
                                                alignItems="flex-start"
                                                justifyContent="center"
                                                mb={
                                                    idx !== item.points.length - 1
                                                        ? index == 0
                                                            ? 6
                                                            : index === 2
                                                            ? 3.5
                                                            : index === 3
                                                            ? 6
                                                            : 2.5
                                                        : 0
                                                }
                                                width="100%"
                                            >
                                                <img
                                                    src="/images/yellow-bulb-icon.svg"
                                                    alt="idea"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        marginTop: "4px",
                                                        marginRight: "10px",
                                                        flexShrink: 0,
                                                    }}
                                                />
                                                <Typography
                                                    fontSize="16px"
                                                    fontWeight="700"
                                                    color="#000"
                                                    lineHeight="1.4"
                                                    textAlign="left"
                                                    whiteSpace="normal"
                                                >
                                                    {point}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            ))}

                            <Box textAlign="center" mb={15}> 
                                <Button
                                    onClick={() => onSelectAmount("price_1QV4J8KAXtGoEI6mJntRzF1L")}
                                    sx={{
                                        background:
                                            "linear-gradient(91deg, rgba(154, 255, 249, 0.40) 18.86%, rgba(255, 240, 109, 0.40) 100.02%)",
                                        borderRadius: "50px",
                                        padding: "11px 4px 11px 4px",
                                        fontWeight: 700,
                                        fontSize: "16px",
                                        color: "#1877F2",
                                        textTransform: "none",
                                        boxShadow:
                                            "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        border: "2px solid #1877F2",
                                        width: "94%",
                                    }}
                                >
                                    BUY THE PLAN NOW @ $1/MONTH
                                </Button>
                            </Box> 
                        </Box>*/}
                    </Box>
                </div>
            )}
            <div
                style={{
                    position: "fixed",
                    bottom: "0",
                    backgroundColor: "white",
                    width: "105%",
                    zIndex: "100",
                    marginBottom: "0px",
                }}
                className="mobile-view"
            >
                <BottomNavigation showLabels>
                    <BottomNavigationAction
                        label="Top Portfolios"
                        onClick={() => navigate("/portfolio-gallery")}
                        icon={
                            <img
                                src={loc === "/portfolio-gallery" ? "/images/dashboardS.svg" : "/images/dashboardU.svg"}
                            />
                        }
                    />
                    <BottomNavigationAction
                        label="My Portfolios"
                        onClick={() => {
                            navigate(userData ? "/my-portfolio" : "/audit-my-portfolio");
                        }}
                        icon={
                            <img src={loc === "/my-portfolio" ? "/images/portfolioS.svg" : "/images/portfolioU.svg"} />
                        }
                    />
                    <BottomNavigationAction
                        label="Crypto Screener"
                        onClick={() => {
                            navigate("/crypto-screener");
                        }}
                        icon={
                            <img
                                src={loc === "/subscriptions" ? "/images/dollarS.svg" : "/images/dollarU.svg"}
                                width={24}
                                height={24}
                                alt="Icon"
                                style={{marginBottom: "-3px"}}
                            />
                        }
                    />
                </BottomNavigation>
            </div>
            {isLoginModalOpen && !isLoggedIn && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen}
                    onClose={handleModalClose}
                />
            )}
            <GoogleLoginHandler redirectUrl={location.pathname} />
        </div>
    );
};

export default MySubscription;
